var slideLarge  = require("app/theme/assets/fallback-slide.3840x1280.en.png"),
    slideMedium = require("app/theme/assets/fallback-slide.2560x1280.en.png"),
    slideSmall  = require("app/theme/assets/fallback-slide.1920x1280.en.png"),
    slideTiny   = require("app/theme/assets/fallback-slide.1280x1280.en.png");

module.exports = function() {
    return [{
        serial_nr: 1,
        key:       "fallback-slide-1",
        type:      "slide",
        link_to:   null,
        img_set:   [{
            width:        1280,
            height:       1280,
            aspect_ratio: 1280 / 1280,
            url:          slideTiny
        }, {
            width:        1920,
            height:       1280,
            aspect_ratio: 1920 / 1280,
            url:          slideSmall
        }, {
            width:        2560,
            height:       1280,
            aspect_ratio: 2560 / 1280,
            url:          slideMedium
        }, {
            width:        3840,
            height:       1280,
            aspect_ratio: 3840 / 1280,
            url:          slideLarge
        }]
    }];
};
